import classNames from 'classnames';
import { getLabelsByLanguage } from '../../../../utilites/util';

interface Props {
  activeStep: number;
}

const StepList: React.FC<Props> = ({ activeStep }) => {
  const labels = getLabelsByLanguage();

  return (
    <ul className="ytope-progress ytope-progress-list ytope-progress-list--v3 d-flex justify-content-center text-15">
      <li
        className={`ytope-step ytope-progress-list__item ${classNames(
          activeStep === 1 && 'ytope-step--active'
        )} ${classNames(activeStep > 1 && 'ytope-step--done')}`}
      >
        <span className="ytope-step__num">
          <span>1</span>
        </span>
        <span className="ytope-step__text">
          {labels.topupText4} <br /> {labels.topupText5}
        </span>
      </li>
      <li
        className={`ytope-step ytope-progress-list__item ${classNames(
          activeStep === 2 && 'ytope-step--active'
        )} ${classNames(activeStep > 2 && 'ytope-step--done')}`}
      >
        <span className="ytope-step__num">
          <span>2</span>
        </span>
        <span className="ytope-step__text">
          {labels.topupText6} <br /> {labels.topupText7}
        </span>
      </li>
      <li className={`ytope-step ytope-progress-list__item ${classNames(activeStep === 3 && 'ytope-step--active')}`}>
        <span className="ytope-step__num">
          <span>3</span>
        </span>
        <span className="ytope-step__text">
          {labels.topupText8} <br /> {labels.topupText9}
        </span>
      </li>
    </ul>
  );
};

export default StepList;
